import { CAMPAIGN_TYPES, CAMPAIGN_TYPES_KEYS } from 'containers/AwarenessCenter/constants'

import { GET_CAMPAIGN_ASYNC, INIT_EDIT_MODE } from './constants'

export default function () {
  const initialState = {
    loader: false,
    campaignType: CAMPAIGN_TYPES.SIMULATION,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case INIT_EDIT_MODE:
        return {
          ...state,
          loader: true,
        }
      case GET_CAMPAIGN_ASYNC.SUCCESS:
        return {
          ...state,
          loader: false,
          campaignType: CAMPAIGN_TYPES_KEYS[action.payload.campaignType],
        }
      case GET_CAMPAIGN_ASYNC.ERROR:
        return {
          ...state,
          loader: false,
        }
      default:
        return state
    }
  }
}
